import { render, staticRenderFns } from "./LessonComponent.vue?vue&type=template&id=e3856486&scoped=true"
import script from "./LessonComponent.vue?vue&type=script&lang=ts"
export * from "./LessonComponent.vue?vue&type=script&lang=ts"
import style0 from "./LessonComponent.vue?vue&type=style&index=0&id=e3856486&prod&scoped=true&lang=css"
import style1 from "./LessonComponent.vue?vue&type=style&index=1&id=e3856486&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3856486",
  null
  
)

export default component.exports